<template>
  <CustomerAddresses />
</template>

<script setup>
import CustomerAddresses from "./CustomerAddresses.vue";
</script>
